export default __webpack_public_path__ + "static/media/logo-us-westelm.144e86bf.svg";